import React, { FC } from 'react';
import SubHeader from 'components/form/header/subheader';
import { SmallSpacer } from 'components/spacer/spacer';
import RadioGroup from 'components/form/radio/radio-group';
import RadioButton from 'components/form/radio/radio-button';
import { fillCycleFilterOptions } from 'constants/index';

interface FillCycleFilterProps {
  value: number;
  onChange: (value: number) => void;
}

const FillCycleFilter: FC<FillCycleFilterProps> = ({ value, onChange }) => {
  return (
    <>
      <SubHeader name="FILL CYCLE" />
      <SmallSpacer />
      <RadioGroup horizontal onChange={onChange}>
        {fillCycleFilterOptions.map(({ label, width }, index) => (
          <RadioButton
            value={index + 1}
            maxItemWidth={width}
            key={`fill-cycle-radio-${label}`}
            checked={value === index + 1}
          >
            {label}
          </RadioButton>
        ))}
      </RadioGroup>
    </>
  );
};

export default FillCycleFilter;
